<template>
  <div class="container">
    <h3 class="title">Proszę podać informacje niezbędne<br/> do odnalezienia polisy.</h3>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler">Podaj dane</button>
    </div>
    <modal name="help-modal" :width="500">
      <form @submit.prevent="setUserPhone">
        <button @click="$modal.hide('help-modal')" class="modal-close" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5999 1.40002L7.9999 8.00002M1.3999 14.6L7.9999 8.00002M7.9999 8.00002L1.3999 1.40002M7.9999 8.00002L14.5999 14.6" :stroke="$color" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <h3 class="modal-title">WERYFIKACJA POLISY</h3>

        <h4 class="modal-subtitle" v-if="!showNumberInput">Podaj numer kontaktowy</h4>
        <h4 class="modal-subtitle" v-else>Podaj {{auth.podaj}}</h4>
        <div class="field">
          <input type="text" class="input" v-model="phone" :class="{ error }" v-if="!showNumberInput" @input="validatePhone">
          <input type="text" class="input" v-model="number" :class="{ error }" v-else @input="auth.validator">

          <div class="arrow" v-if="error" @click="errorHandler">
            <img src="../../assets/images/error_ico.svg" alt="">
          </div>
          <button type="submit" class="arrow" v-else>
            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3415 0.247437C15.7571 -0.116245 16.3889 -0.0741276 16.7526 0.341509L23.7526 8.34151C24.0825 8.71853 24.0825 9.28149 23.7526 9.65852L16.7526 17.6585C16.3889 18.0742 15.7571 18.1163 15.3415 17.7526C14.9259 17.3889 14.8837 16.7571 15.2474 16.3415L20.7962 10H1C0.447715 10 0 9.5523 0 9.00001C0 8.44773 0.447715 8.00001 1 8.00001H20.7962L15.2474 1.65852C14.8837 1.24288 14.9259 0.611119 15.3415 0.247437Z" :fill="$color"/>
            </svg>
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: "StepVerification",
  data () {
    return {
      phone: '',
      number: '',
      showNumberInput: false,
      error: false,

      authOptions: {
        pesel: {
          podaj: 'numer PESEL',
          validator: this.validateNumber
        },
        userName: {
          podaj: 'imię i nazwisko',
          validator: this.validateFullName
        },
        policy: {
          podaj: 'numer polisy',
          validator: this.validatePolicy
        }
      }
    }
  },
  computed: {
    ...mapState(['pesel', 'userName', 'userData', 'policy']),
    auth() {
      return this.authOptions[this.$auth];
    }
  },

  methods: {
    ...mapMutations(['setUserData', 'setVerificationResult', 'setPesel', 'setUserName', 'setPolicy']),
    ...mapActions(['findPolicy']),

    setUserPhone () {
      if (this.phone && !this.userData.PhoneNumber) {
        if (this.error) return
        this.setUserData({ PhoneNumber: this.phone })
        this.showNumberInput = true
        this.phone = ''
      } else if (this.number && !this.userData.pesel && !this.userData.userName && !this.userData.policy) {
        if (this.error) return
        this.findPolicy({
          value: this.number,
          searchType: {
            userName: 'name',
            pesel: 'pesel',
            policy: 'policy'
          }[this.$auth],
          saxId: this.$saxId
        }).then(res => {
          if (res.data.InsurancePolicies.length) {

            // Calling mutation depending on auth method
            this[`set${this.$auth[0].toUpperCase()}${this.$auth.slice(1)}`](this.number)

            this.setVerificationResult(res.data.InsurancePolicies[0])
            this.$emit('setStep', 'result')
          } else {
            this.setVerificationResult(null)
            this.$emit('setStep', 'noResult')
          }
          this.number = ''
        }).catch(err => {
          console.error(err);
          this.setVerificationResult(null)
          this.$emit('setStep', 'noResult')
          this.number = ''
        })
        this.showNumberInput = false
        this.$modal.hide('help-modal')
      }
    },


    validatePhone () {
      const phoneValidation = new RegExp('\\+*[\\(\\)\\-\\d\\s]{9,}')
      this.error = !phoneValidation.test(this.phone)
    },
    validateNumber () {
      const numberValidation = new RegExp('\\d{11}')
      this.error = !numberValidation.test(this.number)
    },
    validatePolicy () {
      const numberValidation = new RegExp('\\d{5,20}')
      this.error = !numberValidation.test(this.number)
    },
    validateFullName () {
      const nameValidation = new RegExp('[^\\s]\\s+[^\\s]')
      this.error = !nameValidation.test(this.number)
    },


    btnHandler () {
      if (this.pesel || this.userName || this.policy) {
        this.$emit('setStep', 'result')
      } else {
        this.$modal.show('help-modal')
      }
    },
    errorHandler () {
      this.phone = ''
      this.number = ''
      this.error = false
      return false
    }
  },
  mounted () {
    this.phone = this.userData.PhoneNumber
    this.showNumberInput = !!this.phone
  },
  props: {
    activeStep: {}
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepVerification.vue